import { filter, map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'
import {
  getActivePackage,
  getActivePackageKey,
  getActivePackagePriceInfos,
  getPickersSelectionPrice,
  getPriceInfosFromActivePackageInFilteredProducts
} from 'store/selectors'

const toggleCheapestPrice = (actions$, state$) => actions$.pipe(
  ofType(Actions.configurator.CONFIGURATOR_SELECTION_CHANGE),
  filter((action) => action.payload.shouldDetectCheapestPrice),
  map(() => {
    const state = state$.value

    if (!getActivePackage(state)) { return {} }

    const activePackageKey = getActivePackageKey(state)
    const pickersSelectionPrice = getPickersSelectionPrice(state)
    const priceInfos = getActivePackagePriceInfos(state)
    const priceInfosFromFilters = getPriceInfosFromActivePackageInFilteredProducts(state)

    if ((priceInfosFromFilters && pickersSelectionPrice?.price === priceInfosFromFilters.price) || (!priceInfosFromFilters && pickersSelectionPrice?.price === priceInfos.price)) {
      return Actions.configurator.onCheapestPriceToggleActivation(activePackageKey)
    }

    return Actions.configurator.onCheapestPriceToggleReset(activePackageKey)
  })
)

export default toggleCheapestPrice
